import { ServicePackageType } from '../graphql/generatedTypes';
import i18n from './i18n';

export function getServicePackageDisplayName(
  servicePackage: ServicePackageType | null | undefined,
): string {
  if (!servicePackage) return i18n.t('GeneralAdminInfo:servicePackageNone');
  switch (servicePackage) {
    case ServicePackageType.Basic:
      return i18n.t('GeneralAdminInfo:servicePackageBasic');
    case ServicePackageType.Essential:
      return i18n.t('GeneralAdminInfo:servicePackageEssential');
    case ServicePackageType.Enterprise:
      return i18n.t('GeneralAdminInfo:servicePackageEnterprise');
    case ServicePackageType.ProPlus:
      return i18n.t('GeneralAdminInfo:servicePackageProPlus');
    default:
      return servicePackage;
  }
}

export function getServicePackageColor(
  servicePackage: ServicePackageType | null | undefined,
): string {
  if (!servicePackage) return 'transparent';
  switch (servicePackage) {
    case ServicePackageType.Basic:
      return '#e7e7e7';
    case ServicePackageType.Essential:
      return '#1cc282';
    case ServicePackageType.Enterprise:
      return '#e8d6fb';
    case ServicePackageType.ProPlus:
      return '#dc5a38';
    default:
      return 'transparent';
  }
}

export function getServicePackageTextColor(
  servicePackage: ServicePackageType | null | undefined,
): string {
  if (
    !servicePackage ||
    servicePackage === ServicePackageType.Basic ||
    servicePackage === ServicePackageType.Enterprise
  ) {
    return 'inherit';
  }
  return '#fff';
}
